import React from "react";

const DashboardContainerHeader = ({ text, classNames }) => {
  return (
    <div
      className={
        " px-5 w-full py-3 rounded-t-xl border-b text-xl sans-bold text-gray-900 dark:text-white bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-gray-700 " +
        classNames
      }
    >
      {text}
    </div>
  );
};

export default DashboardContainerHeader;
